/*
* 系统应用相关api(登录、登出、密码)
* */
const commonApi = {
  paramList: '/kbms/config/param/list', // 全局参数/字典配置
}

export default commonApi
